import classNames from 'classnames'
import { h, JSX } from 'preact'
import { useEffect, useState } from 'preact/hooks'

export interface TimerProps {
    modifier?: string
    class?: string
    endTime: number // Unix timestamp in milliseconds
    label?: string
}

const getTimeText = (remaining: number) => {
    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60

    const minutesText = String(minutes).padStart(2, '0')
    const secondsText = String(seconds).padStart(2, '0')

    return `${minutesText}:${secondsText}`
}

const getRemainingSeconds = (endTime: number) => {
    const ms = endTime - Date.now()
    return Math.floor(ms / 1000)
}

export const Timer = (props: TimerProps): JSX.Element => {
    const [remaining, setRemaining] = useState(() => getRemainingSeconds(props.endTime))

    useEffect(() => {
        const handle = window.setInterval(() => {
            const newRemaining = getRemainingSeconds(props.endTime)

            if (newRemaining > 0) {
                setRemaining(newRemaining)
            } else {
                setRemaining(0)
                window.clearInterval(handle)
            }
        }, 200)

        return () => window.clearInterval(handle)
    }, [props.endTime])

    return (
        <div class={classNames('timer', props.modifier, props.class)}>
            {props.label && <span class="timer__label">{props.label}</span>}
            <span class="timer__clock">{getTimeText(remaining)}</span>
        </div>
    )
}
